const URL_PARAMS = {
  ACCOMMODATION_TYPE_IDS: 'accommodationTypeIds',
  CURRENCY: 'currency',
  DESTINATIONS: 'destinations',
  DURATIONS: 'durations',
  FROM_DATE: 'fromDate',
  MATCHES: 'matches',
  MAX_PRICE: 'maxPrice',
  MIN_PRICE: 'minPrice',
  PACKAGE_TYPES: 'packageTypes',
  PAGE: 'page',
  PRICE_FROM: 'priceFrom',
  PRICE_TO: 'priceTo',
  RESULTS_PER_PAGE: 'resultsPerPage',
  SITE_ID: 'siteId',
  SORT_ORDER: 'sortOrder',
  TOURNAMENTS: 'tournaments',
};

export default URL_PARAMS;
